import { publish, withNamespace } from "util/custom-event";

const eventName = withNamespace('TableFilters');

export const apply = () => publish(apply.eventName, null);

apply.eventName = eventName('Apply');
